import StoryblokImageBasic, { GetImageUrlAndTagSize } from "../storyblokImageBasic/storyblokImageBasic"

import { useStoryblokGlobalSettings } from "../../hooks/useStoryblokGlobalSettings"

import styles from "./legacyThumbnail.module.scss"
import RouterLink from "../link/RouterLink";
import { buildInternalPath } from "../../helpers/URLHelpers";

function LegacyThumbnail({ to, thumbnail_image, width }) {
  const globalSettings = useStoryblokGlobalSettings()

  let backgroundUrl = ""
  if(globalSettings && globalSettings.thumbnail_legacy_background_image) {
    backgroundUrl = GetImageUrlAndTagSize(globalSettings.thumbnail_legacy_background_image).url
  }

  if(!thumbnail_image || !thumbnail_image.filename) {
    return null
  }
  return (
    <RouterLink
      to={buildInternalPath(to)}
      className={styles.legacyThumbnailWrapper}
    >
      <div
        className={styles.legacyThumbnailContainer}
        style={{
          backgroundImage: `url('${backgroundUrl}')`,
        }}
      >
        <StoryblokImageBasic image={thumbnail_image} width={width} />
      </div>
    </RouterLink>
  );
}

export default LegacyThumbnail
